var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon-button',{staticClass:"mute-controller",class:{ __muted: _vm.viewer.muted },attrs:{"loading":_vm.loading},on:{"click":_vm.toggleMute}},[_vm._v(" "+_vm._s(_vm.viewer.muted ? "sci-volume-off" : "sci-volume-up")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }